<template>
  <div>
    <iframe
      v-if="selectPlugin != null"
      id="show-plugin"
      ref="iframeShareMenu"
      style="width: 100%; height: 100%"
      frameBorder="0"
    ></iframe>
  </div>
</template>


<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      selectedPlugin: null,
      iframeController: null,
      selectedFilesFromParent:{}
    };
  },
  watch: {
    pluginInfo(ol, nl) {
      console.log("this.pluginInfo.pluginName",this.pluginInfo.pluginName)
      if (ol != nl) {
        setTimeout(() => this.selectPlugin(this.pluginInfo.pluginName), 100);
      }
    },
  },
  methods: {
    selectPlugin(plugin) {
      this.selectedPlugin = plugin;
      this.loadExternalPluginForShareMenu({
        id: this.pluginInfo.id,
        pluginName: this.selectedPlugin,
        tagId: "show-plugin",
      });
      this.iframeController = this.$refs.iframeShareMenu.contentWindow;
    },
    damNotificationCallback() {
      // this.iframeController.postMessage(
      //   {
      //     cmd: "readyToListenMessage",
      //     params:  {
      //                 selected_file_info:Object.assign({},this.selectedFileInfo)
      //               }
      //   },
      //   "*"
      // );
      window.addEventListener('message', (event)=>{
            let cmd = event.data.cmd
            switch (cmd) {
              case 'readyToListenMessage':{
                  this.iframeController.postMessage({
                    cmd: 'fileinfo',
                    params: {
                      selected_file_info:this.selectedFileInfo
                    }
                    }, '*')
                  break;
                }
              default:
                break;
            }
          }
          )
    },
   listenMessagesFromChild(){
          window.addEventListener('message', (event)=>{
            let cmd = event.data.cmd;
            switch (cmd) {
              case 'closeShareWindow':{
                this.$emit("closeWindow")
                break;
              }
              default:
                break;
            }
          }
          )
        },
    ...mapMutations("registry", [
      "loadExternalPluginForShareMenu",
    ]),
    ...mapMutations("websocket", ["addWSEventListener"]),
  },
  props: ["pluginInfo","selectedFileInfo"],
  created() {
    this.selectedFilesFromParent = this.selectedFileInfo;
    this.listenMessagesFromChild();
    this.damNotificationCallback();
  },
  mounted() {
    setTimeout(() => this.selectPlugin(this.pluginInfo.pluginName), 100);
  },
};
</script>


<style lang="scss" scoped>
$header-background: #1a1a1a;
$border-color: 1px solid #3a3a3a;
$background: #121212;
$background-color-on-hover: #141414;
$body-background-color: #141414;
$dull-text-color: #858585;
$options-text-color: #9c9c9c;
$icon-color-on-hover: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$input-field-bg-color: #121212;
$input-field-border-color: #202020;
$input-field-height:38px;
$button-height:38px;
$secondary-border-color: 1px solid #3a3a3a;
$searchBar-border-color: 1px solid #202020;
$secondary-text-color: #bbb;
$modal-border:1px solid #202020;
$modal-background: #121212;
$header-color:#9e9e9e;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#141414;
$scrollbar-thumb-on-hover-background:#555;
$input-field-padding:.375rem .75rem;
$input-field-and-label-font-size:14px;

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

html {
  overflow: auto;
}

select option {
  margin: 40px;
  background: #000;
  color: #fff;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
}
</style>


